import React from "react";
import {Link} from "react-router-dom";
import "./Footer.css";
import Logo from "../assets/logo-footer.svg";
import LogoMark from "../assets/logo-mark-footer.svg";
import Line from "../assets/chat-bubble.svg";
import LinkedinIcon from "../assets/linkedin-icon.svg";

function Footer() {
    return (
        <footer>
            {/* Footer Container */}
            <section className="footer-container">
                {/* Contact-info */}
                <section className="footer-info">
                    <section className="footer-info-details">
                        <h6> Info</h6>
                        <div className="info-details">
                                <a href="/">Home</a>
                                <a href="/pricing">Pricing</a>
                                <a href="/blog">Blog</a>
                                <a href="/about">About</a>
                                <a href="/schedule-demo">Contact</a>
                        </div>
                    </section>
                    <section className="footer-legal">
                        <h6>Legal</h6>
                        <div className="info-details">
                                <a href="/privacy-policy">Privacy Policy</a>
                                <a href="/terms-of-use">Terms of Use</a>
                        </div>
                    </section>
                </section>
                {/* social media */}
                <section className="footer-social-media">
                    <div className="footer-social-media-details">
                        <div className="footer-social-media-container">
                            <figure>
                                <img
                                    src={LinkedinIcon}
                                    alt="linkedin icon"
                                    className="linkedin-icon"
                                />
                            </figure>
                            <p style={{width: '100px', marginLeft: '10px'}}>
                                <a
                                    href="https://www.linkedin.com/company/magic-feedback/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    Follow us
                                </a>
                            </p>
                        </div>
                        <div className="footer-drop-line">
                            <figure>
                                <img src={Line} alt="drop-line"/>
                            </figure>
                            <p style={{width: '100px', marginLeft: '10px'}}>
                                <a href="/schedule-demo">Drop a line</a>
                            </p>
                        </div>
                    </div>
                </section>
            </section>
            {/* Rights Statement  */}
            <section className="rights-statement">
                <div className="rights">
                    <figure className="footer-logo-container">
                        <img
                            src={LogoMark}
                            alt="logo-mark"
                            className="logo-mark-footer"
                        />
                        <img src={Logo} alt="logo" className="logo-footer"/>
                    </figure>
                    <small>© 2024 Magic Feedback All rights reserved.</small>
                </div>
                <small>AI-powered customer feedback analysis and management.</small>
            </section>
        </footer>
    );
}

export default Footer;
